/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_Step_3_DescInputs */

const en_mk_desktop_step_3_desc = /** @type {(inputs: Mk_Desktop_Step_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select “Start connection”. Choose this computer on the Bystep web Build page, then start your work.`)
};

const id_mk_desktop_step_3_desc = /** @type {(inputs: Mk_Desktop_Step_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik “Jalankan koneksi”. Pilih komputer ini di halaman Bangun pada web Bystep, lalu mulai pekerjaan.`)
};

/**
* | output |
* | --- |
* | "Select “Start connection”. Choose this computer on the Bystep web Build page, then start your work." |
*
* @param {Mk_Desktop_Step_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_step_3_desc = /** @type {((inputs?: Mk_Desktop_Step_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_Step_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_step_3_desc(inputs)
	return en_mk_desktop_step_3_desc(inputs)
});